import { Modal, Tab } from 'bootstrap';
var numeral = require('numeral');

jQuery(document).ready(function ($) {

	// set position of calulcator nav
	function updateNavTabsPosition() {
		let calcDescHeight = $(".tab-pane.active .calculator-description img").outerHeight() +
			$(".tab-pane.active .calculator-description h3").outerHeight() +
			$(".tab-pane.active .calculator-description p").outerHeight();
		if (calcDescHeight) {
			$("#calculators-nav").css("top", calcDescHeight + 152 + "px");
		}
	}

	// set modal name
	function updateModalHeader() {
		let activeTabText = $(".nav-tabs .nav-link.active").text().trim(); // Get the active tab text
		$(".modal.calculator .modal-header .modal-title strong").text(activeTabText); // Set modal title
	}

	//function updateReverseLayout() {
	//	// Select the last calculator-row
	//	var lastCalculatorRow = $('#reverse .calculator-row').last();

	//	// Select the next-to-last calculator-row
	//	var secondLastCalculatorRow = $('#reverse .calculator-row').eq($('#reverse .calculator-row').length - 2);

	//	// Select the last two .col-sm-12.col-md-6.col-lg-4 divs inside the second-to-last calculator-row
	//	var lastTwoCols = secondLastCalculatorRow.find('.col-sm-12.col-md-6.col-lg-4').slice(-2);
	//	console.log(lastTwoCols);
	//	// Select the .calculator-results container
	//	var calculatorResults = $('#reverse .calculator-results');

	//	// Move the last calculator-row and the last two cols to the .calculator-results container
	//	calculatorResults.append(lastTwoCols).append(lastCalculatorRow);
	//}

	// Navigate to correct tab when modal is triggered
	$('.cta--modalTrigger[data-tab-target]').on('click', function (event) {
		var targetTabId = $(this).attr('data-tab-target'); // Get tab ID

		setTimeout(function () {
			if (targetTabId) {
				var tabElement = document.querySelector(targetTabId); // Get tab element
				var targetTab = new Tab(tabElement);
				targetTab.show();

				updateNavTabsPosition();
			}
		}, 200);
	});

	// Run on page load
	//updateNavTabsPosition();

	// Update when a tab is changed
	$('button[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
		updateNavTabsPosition();
		updateModalHeader();
	});

	// Update when the calculator modal is opened
	//$(".modal.calculator").on("shown.bs.modal", function () {
		//updateNavTabsPosition();
		//updateModalHeader();
		//updateReverseLayout();
	//});


	// PMT calculator function
	var PMT = function (rate, nper, pv, fv, type) {
		if (!fv) fv = 0;
		if (!type) type = 0;

		if (rate == 0) return -(pv + fv) / nper;

		var pvif = Math.pow(1 + rate, nper);
		var pmt = rate / (pvif - 1) * -(pv * pvif + fv);

		if (type == 1) {
			pmt /= (1 + rate);
		};

		return pmt;
	};

	var requireValues = function ($calculator, callback) {

		var pass = true;

		$calculator.find('input[data-required="true"]').each(function () {
			if (!$(this).val()) {

				$(this).addClass('required-value');
				pass = false;

			} else {

				$(this).removeClass('required-value');

			}
		});

		callback(pass);

	};

	// format
	$('.format-input').on('keydown', function (event) {

		var _this = {};

		// Allow: backspace, delete, tab, escape, enter and .
		if ($.inArray(event.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
			// Allow: Ctrl+A
			(event.keyCode == 65 && event.ctrlKey === true) ||
			// Allow: Ctrl+C
			(event.keyCode == 67 && event.ctrlKey === true) ||
			// Allow: Ctrl+X
			(event.keyCode == 88 && event.ctrlKey === true) ||
			// Allow: home, end, left, right
			(event.keyCode >= 35 && event.keyCode <= 39)) {
			// let it happen, don't do anything
			return;
		}
		// Ensure that it is a number and stop the keypress
		if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
			event.preventDefault();
		}

		if (_this.timer) {
			clearTimeout(_this.timer);
		}

		_this.timer = setTimeout(function () {

			var $input = $(event.currentTarget);
			var value = $input.val();
			var format = $input.attr('data-format');

			if (format == 'currency') {
				var formatted = numeral(value).format('0,0');
				$input.val(formatted);
			}

			_this.timer = null;

		}, 500);

	})



	$('.trigger-show-advanced').on('click touchstart', function (event) {

		event.preventDefault();

		var $button = $(event.currentTarget);

		var $advancedOptions = $button.parents('.calculator').find('.advanced-options');

		$advancedOptions.slideToggle();

	});

	/*
	*
	*
	* Update Monthly Payment Fields
	*
	*
	*/
	$('.trigger-update-fields').on('keyup', function (event) {


		var _this = {};

		if (_this.timer) {
			clearTimeout(_this.timer);
		}

		_this.timer = setTimeout(function () {

			var $target = $(event.currentTarget);

			var $calculator = $target.parents('.calculator');
			var $price = $calculator.find('input[name="purchase_price"]');
			var $percent = $calculator.find('input[name="down_payment_percent"]');
			var $loan = $calculator.find('input[name="mortgage_amount"]');

			if (!$price.val() || !$percent.val() || !$loan.val()) {
				return;
			}

			var purchasePrice = parseFloat($price.val().replace(/,/g, ''));
			var downPaymentPercentage = Number($percent.val()) / 100;
			var mortgageAmount = parseFloat($loan.val().replace(/,/g, ''));

			if ($target.attr('name') === 'mortgage_amount') {
				//calculate percent
				var percent = (1 - (mortgageAmount / purchasePrice)) * 100;
				$percent.val(percent.toFixed())

			} else {
				//calcluate loan amount
				var loanAmount = purchasePrice * (1 - downPaymentPercentage);
				$loan.val(numeral(loanAmount).format('0,0'))
			}

			_this.timer = null;

		}, 500);
	})

	/*
	*
	*
	* Monthly Payment 
	*
	*
	*/
	$('.trigger-calculate-monthly').on('click touchstart', function (event) {

		event.preventDefault();

		var $button = $(event.currentTarget);

		$button.addClass('loading');

		// context
		var $calculator = $button.parents('.calculator');

		requireValues($calculator, function (proceed) {

			if (!proceed) {
				$button.removeClass('loading').text('Recalculate');
				return;
			}


			// setup display fields
			var $loanAmountDisplay = $calculator.find('#purchase .display-loan-amount'); 
			var $monthlyPaymentDisplay = $calculator.find('#purchase .display-monthly-payment');
			$monthlyPaymentDisplay.removeClass('fadeText')
			var $totalPaymentDisplay = $calculator.find('#purchase .display-total-payment');

			// collect input values	
			var purchasePrice = parseFloat($calculator.find('#purchase input[name="purchase_price"]').val().replace(/,/g, ''));
			var downPaymentPercentage = Number($calculator.find('#purchase input[name="down_payment_percent"]').val()) / 100;
			//var mortgageAmount = parseFloat($calculator.find('#purchase input[name="mortgage_amount"]').val().replace(/,/g, ''));
			var mortgageTerm = Number($calculator.find('#purchase select[name="mortgage_term"]').val()) * 12;
			var mortgageInterest = Number($calculator.find('#purchase input[name="mortgage_interest"]').val()) / 100 / 12;

			//console.log(purchasePrice);
			//console.log(downPaymentPercentage)

			// calculate
			var mortgageAmount = purchasePrice * (1 - downPaymentPercentage);
			var monthlyPayment = mortgageAmount * mortgageInterest * (Math.pow(1 + mortgageInterest, mortgageTerm)) / (Math.pow(1 + mortgageInterest, mortgageTerm) - 1);

			setTimeout(function () {
				$loanAmountDisplay.addClass('.fadeText').text(numeral(mortgageAmount).format('$0,0'));
				$monthlyPaymentDisplay.addClass('fadeText').text(numeral(monthlyPayment).format('$0,0'));

				$totalPaymentDisplay.text(numeral(monthlyPayment * mortgageTerm).format('$0,0'));

				$button.removeClass('loading').text('Recalculate');

			}, 600);
		});

	});

	/*
	*
	*
	* Refinance Savings Payment 
	*
	*
	*/
	$('.trigger-calculate-refinance').on('click touchstart', function (event) {

		event.preventDefault();

		var $button = $(event.currentTarget);

		var date = new Date();

		$button.addClass('loading');

		// get context
		var $calculator = $button.parents('.calculator');

		requireValues($calculator, function (proceed) {

			if (!proceed) {
				$button.removeClass('loading').text('Recalculate');
				return;
			}

			// setup display fields
			var $annualSavingsDisplay = $calculator.find('#refinance .display-annual-savings');
			$annualSavingsDisplay.removeClass('fadeText')
			var $monthlyPaymentSavingsDisplay = $calculator.find('#refinance .display-monthly-savings');
			var $newMonthlyPaymentDisplay = $calculator.find('#refinance .display-new-monthly-payment');
			var $totalInterestSavingsDisplay = $calculator.find('#refinance .display-total-interest-savings');
			var $interestDifferenceDisplay = $calculator.find('#refinance .display-interest-difference');

			// collect input values
			var originalLoan = parseFloat($calculator.find('#refinance input[name="original_loan_amount"]').val().replace(/,/g, ''));
			var originalInterest = Number($calculator.find('#refinance input[name="original_rate"]').val()) / 100 / 12;
			var originalTerm = Number($calculator.find('#refinance select[name="original_term"]').val()) * 12;
			var originationDate = Number($calculator.find('#refinance input[name="origination_date"]').val())
			var newTerm = Number($calculator.find('#refinance select[name="new_term"]').val()) * 12;
			var newInterest = Number($calculator.find('#refinance input[name="new_rate"]').val()) / 100 / 12;
			var newLoan = parseFloat($calculator.find('#refinance input[name="new_loan"]').val().replace(/,/g, ''));

			// calculate
			var originalMonthlyPayment = originalLoan * originalInterest * (Math.pow(1 + originalInterest, originalTerm)) / (Math.pow(1 + originalInterest, originalTerm) - 1)

			var paidTerms = (Number(date.getFullYear()) - originationDate) * 12;
			var termRemaining = originalTerm - paidTerms;
			var balanceRemaining = originalLoan - (originalMonthlyPayment * paidTerms);
			var newMonthlyPayment = newLoan * newInterest * (Math.pow(1 + newInterest, newTerm)) / (Math.pow(1 + newInterest, newTerm) - 1);

			var interestDif = (newMonthlyPayment * newTerm) - (originalMonthlyPayment * termRemaining);

			var monthlySavings = originalMonthlyPayment - newMonthlyPayment;

			var newAnnual = (newMonthlyPayment * 12);

			var annualSavings = (originalMonthlyPayment * 12) - newAnnual;


			// Load results
			setTimeout(function () {

				$annualSavingsDisplay.addClass('fadeText').text(numeral(annualSavings).format('$0,0'));
				$monthlyPaymentSavingsDisplay.text(numeral(monthlySavings).format('$0,0'));
				$newMonthlyPaymentDisplay.text(numeral(newMonthlyPayment).format('$0,0'));
				$interestDifferenceDisplay.text(numeral(interestDif).format('$0,0'));

				$button.removeClass('loading').text('Recalculate');

			}, 600);
		});

	});


	/*
*
*
* Rent vs Buy
*
*
*/
	$('.trigger-calculate-rent-vs-buy').on('click touchstart', function (event) {

		event.preventDefault();

		var $button = $(event.currentTarget);

		$button.addClass('loading');

		// get context
		var $calculator = $button.parents('.calculator');

		requireValues($calculator, function (proceed) {

			if (!proceed) {
				$button.removeClass('loading').text('Recalculate');
				return;
			}


			// setup display fields
			var $annualSavingsDisplay = $calculator.find('#rent-vs-buy .display-annual-savings');
			$annualSavingsDisplay.removeClass('fadeText')

			// collect input values
			var mortageAmount = parseFloat($calculator.find('#rent-vs-buy input[name="mortgage_amount"]').val().replace(/,/g, ''));
			var term = Number($calculator.find('#rent-vs-buy select[name="mortgage_term"]').val()) * 12;
			var interestRate = Number($calculator.find('#rent-vs-buy input[name="mortgage_interest"]').val()) / 100 / 12;
			var monthlyPayment = parseFloat($calculator.find('#rent-vs-buy input[name="monthly_rental_payment"]').val().replace(/,/g, ''));
			//var propertyTax = parseFloat($calculator.find('input[name="property_tax"]').val().replace(/,/g, ''));
			var propertyTax = 1000;
			//var insurance = parseFloat($calculator.find('input[name="insurance"]').val().replace(/,/g, ''));
			var insurance = 1000;
			//var maintenance = parseFloat($calculator.find('input[name="maintenance"]').val().replace(/,/g, ''));
			var maintenance = 1000;
			//var taxRate = Number($calculator.find('input[name="state_fed_tax_rate"]').val()) / 100;
			var taxRate = 0.25;

			// calculate
			
			// annual fixed home cost
			var fixedHomeCost = propertyTax + insurance + maintenance;

			// monthly loan payment
			var monthlyLoanPayment = mortageAmount * interestRate * (Math.pow(1 + interestRate, term)) / (Math.pow(1 + interestRate, term) - 1);

			var annualLoanCost = monthlyLoanPayment * 12;

			var firstYearInterest = .85 * annualLoanCost;

			var initApprove = .02 * mortageAmount;

			var taxReduction = firstYearInterest * taxRate;

			var intTotOth = annualLoanCost - initApprove - taxReduction;

			var totalAnnualCost = fixedHomeCost + intTotOth;

			var annualSavings = (monthlyPayment * 12) - totalAnnualCost;

			// Load results
			setTimeout(function () {

				$annualSavingsDisplay.addClass('fadeText').text(numeral(annualSavings).format('$0,0'));

				$button.removeClass('loading').text('Recalculate');

			}, 600);
		});

	});


	/*
	*
	*
	* Reverse Mortgage
	*
	*
	*/
	$('.trigger-calculate-reverse').on('click touchstart', function (event) {

		event.preventDefault();

		var $button = $(event.currentTarget);

		$button.addClass('loading');

		// get context
		var $calculator = $button.parents('.calculator');

		requireValues($calculator, function (proceed) {

			if (!proceed) {
				$button.removeClass('loading').text('Recalculate');
				return;
			}
			// setup display fields
			var $locDisplay = $calculator.find('.display-loc');
			$locDisplay.removeClass('fadeText')
			var $qualifyDisplay = $calculator.find('.display-qualify');
			var $locAfterDisaply = $calculator.find('.display-loc-after');
			var $monthlyPaymentDisplay = $calculator.find('.display-monthly-payment');

			// collect input values
			var homeValue = parseFloat($calculator.find('input[name="homeValue"]').val().replace(/,/g, ''));
			//var mortgages = parseFloat($calculator.find('input[name="mortgage_amount"]').val().replace(/,/g, ''));
			var age = Number($calculator.find('select[name="age"]').val());
			var ageSpouse = Number($calculator.find('select[name="age_spouse"]').val());

			var bottomAge;
			var topAge;

			if (!ageSpouse) {
				ageSpouse = age;
			}

			if (age >= ageSpouse) {
				topAge = age;
				bottomAge = ageSpouse;
			} else {
				topAge = ageSpouse;
				bottomAge = age;
			}

			/* calculate
			var maxClaim = homeValue >= 625000 ? 625000 : homeValue;
			
			var plfArray = [{age:18,plf:.317},{age:19,plf:.317},{age:20,plf:.326},{age:21,plf:.326},{age:22,plf:.326},{age:23,plf:.326},{age:24,plf:.326},{age:25,plf:.35},{age:26,plf:.35},{age:27,plf:.35},{age:28,plf:.35},{age:29,plf:.35},{age:30,plf:.373},{age:31,plf:.373},{age:32,plf:.373},{age:33,plf:.373},{age:34,plf:.373},{age:35,plf:.396},{age:36,plf:.396},{age:37,plf:.396},{age:38,plf:.396},{age:39,plf:.396},{age:40,plf:.42},{age:41,plf:.42},{age:42,plf:.42},{age:43,plf:.42},{age:44,plf:.42},{age:45,plf:.443},{age:46,plf:.443},{age:47,plf:.443},{age:48,plf:.443},{age:49,plf:.443},{age:50,plf:.46},{age:51,plf:.46},{age:52,plf:.46},{age:53,plf:.46},{age:54,plf:.46},{age:55,plf:.484},{age:56,plf:.489},{age:57,plf:.495},{age:58,plf:.5},{age:59,plf:.506},{age:60,plf:.511},{age:61,plf:.517},{age:62,plf:.524},{age:63,plf:.53},{age:64,plf:.536},{age:65,plf:.542},{age:66,plf:.549},{age:67,plf:.556},{age:68,plf:.562},{age:69,plf:.569},{age:70,plf:.576},{age:71,plf:.583},{age:72,plf:.591},{age:73,plf:.599},{age:74,plf:.606},{age:75,plf:.614},{age:76,plf:.622},{age:77,plf:.631},{age:78,plf:.64},{age:79,plf:.648},{age:80,plf:.657},{age:81,plf:.665},{age:82,plf:.674},{age:83,plf:.682},{age:84,plf:.69},{age:85,plf:.699},{age:86,plf:.709},{age:87,plf:.719},{age:88,plf:.729},{age:89,plf:.739},{age:90,plf:.75},{age:91,plf:.75},{age:92,plf:.75},{age:93,plf:.75},{age:94,plf:.75},{age:95,plf:.75},{age:96,plf:.75},{age:97,plf:.75},{age:98,plf:.75},{age:99,plf:.75}];
			
			var plf;
			
			for(i=0;i < plfArray.length; i++){
				if(bottomAge === plfArray[i].age) {
					plf = plfArray[i].plf;
				}
			}
			
			var pricipleAmount = plf * maxClaim;
			
			var originationFee = maxClaim >= 400000 ? 6000 
				: maxClaim >= 200000 ? 4000 + (maxClaim - 200000)*.01 
				: maxClaim <= 125000 ? maxClaim * .02 
				: maxClaim == 0 ? 0 : 2500;
							
			var estimatedClosingCost = 	homeValue >= 400000 ? 400000 * .01
				: homeValue >= 200000 ? homeValue * .01
				: homeValue == 0 ? 0 : 2000;	
	
			var mandatoryObligation = originationFee + estimatedClosingCost + mortgages;
			
			var obligationPercent = mandatoryObligation / pricipleAmount;
			
			var mortgageInsurance = obligationPercent <= .6 ? maxClaim * .005
				: maxClaim * 0.025;
			
			var remainingPrinciple = pricipleAmount - estimatedClosingCost - originationFee - mortgageInsurance;
			
			var netProceed = remainingPrinciple - mortgages;
			
			var plUtilization = mandatoryObligation / pricipleAmount;
			
			var fundingAvailable;
			if(plUtilization >= .6){
				if(pricipleAmount * .1 >=  netProceed){
					fundingAvailable = netProceed;
				} else {
					fundingAvailable = pricipleAmount * .1;
				}
			} else {
				fundingAvailable = (pricipleAmount * .6) - estimatedClosingCost - originationFee - mortgageInsurance - mortgages;
			}
			
			var loc = fundingAvailable <= 0 ? 0 : fundingAvailable;
						
			var locAfter = fundingAvailable <= 0 ? 0 : netProceed - loc;			
			
			var monthlyPayment = fundingAvailable < 0 ? 0 : PMT( (.025 + .0194 + .0125) / 12 , (100 - topAge) * 12 , -netProceed , 0, 1);
						
			var qualify = fundingAvailable > 0 ? 'YES' : 'NO';*/

			// Load results
			jQuery.ajax({
				url: "https://corpapi.lhfstest.com/ReverseMortgage/principal-limit",
				data: 'homeValue=' + homeValue + '&borrowerAge=' + age + '&margin=2',
				type: "POST",
				success: function (result) {
					$button.removeClass('loading').text('Recalculate');
					$locDisplay.addClass('fadeText').text(numeral(html(result)).format('$0,0'));
					$qualifyDisplay.text(qualify);
					$locAfterDisaply.text(numeral(locAfter).format('$0,0'));
					$monthlyPaymentDisplay.text(numeral(monthlyPayment).format('$0,0'))
				}
			});
			/*setTimeout(function(){
				$button.removeClass('loading').text('Recalculate');
				$locDisplay.addClass('fadeText').text(numeral(loc).format('$0,0'));
				$qualifyDisplay.text(qualify);
				$locAfterDisaply.text(numeral(locAfter).format('$0,0'));
				$monthlyPaymentDisplay.text(numeral(monthlyPayment).format('$0,0'))
					
			}, 600);*/
		});

	});

});